<template>
  <div class="wiki-detail-comment" :style="{ height: isPage ? 'auto' : '70vh' }">
    <div v-if="needLogin" ref="sendComment" class="detail-comment">
      <send-article-box
        ref="sendBox"
        :on-ok="onComment"
        placeholder="写下友好的评论，有助于彼此更好地交流"
        :send-btn-text="$t('comment')"
        :show-video="false"
        :show-cancel="true"
        :showToolBar="showToolBar"
        @focus="onInputFocus"
        @cancel="onInputCancel"
      >
        <!-- <template v-slot:more>
          <div class="mode-line">
            <div class="mode-btn" @click="handleClickEdit">
              <span style="margin-right: 2px;">投稿模式</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </template> -->
      </send-article-box>
    </div>
    <div v-if="needLogin && list.length" class="wiki-comment-list" :style="{ height: isPage ? 'auto' : 0 }">
      <template v-if="!isPage">
        <el-scrollbar style="height: 100%;">
          <div
            ref="scrollComp"
            v-infinite-scroll="getCommentList"
            :infinite-scroll-delay="350"
            :infinite-scroll-distance="60"
          >
            <!-- <p class="comment-num" id="detail-comment-ancher">
            {{ $t("comments") }}<span>（{{ detail.comment_count }}）</span>
          </p> -->

            <comment-list-item
              v-for="(item, index) in list"
              :key="item.id"
              :floor="'#' + (pagination.total - index)"
              :is-lz="item.user.uid == user.uid"
              :item="item"
              :pid="item.id"
              @onDel="onDelComment"
              @onTop="onTopComment"
            />
          </div>
        </el-scrollbar>
      </template>
      <template v-if="isPage">
        <div class="list">
          <template v-if="list.length">
            <div v-for="(item, index) in list" :key="item.id">
              <comment-list-item
                :floor="'#' + (pagination.total - index)"
                :is-lz="item.user.uid == user.uid"
                :item="item"
                :pid="item.id"
                @onDel="onDelComment"
                @onTop="onTopComment"
              />
              <detail-ad v-if="index == 4" :detail="detail" />
            </div>
            <div class="no-more" v-if="list.length == pagination.total">
              没有更多数据了
            </div>
          </template>
          <template v-else>
            <div class="empty-box">
              <img class="empty-icon" src="@/assets/images/comment-empty-icon.png" alt="" />
              <div class="empty-txt">观看就是喜欢，快来评论一下吧！</div>
              <!-- <div class="btn-box">
                <el-button class="button" type="text">点击评论</el-button>
              </div> -->
            </div>
          </template>
        </div>
      </template>
    </div>
    <div v-else class="empty-box">
      <img class="empty-icon" src="@/assets/images/comment-empty-icon.png" alt="" />
      <div class="empty-txt">观看就是喜欢，快来评论一下吧！</div>
      <!-- <div class="btn-box">
                <el-button class="button" type="text">点击评论</el-button>
              </div> -->
    </div>
    <!-- 查看评论 -->
    <comment-dialog />
    <!-- 游客评论弹窗 -->
    <SightseerCommentTips ref="sightseerCommentTips"></SightseerCommentTips>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import { Message } from "element-ui";
// components
// import ScrollComp from "@/components/Scroll";
import SendArticleBox from "../../../components/sendArticleBox/index.vue";
import CommentListItem from "../../../components/commentListItem";
import CommentDialog from "../../../components/commentDialog";
import SightseerCommentTips from "../../../components/sightseerCommentTips";
import DetailAd from "./detailAd.vue";
// api
import { apiCommentAdd, apiSightseerCommentAdd } from "@/api/commentApi";
// plguins
import eventBus from "@/plugins/eventBus";
import { newDebounce, toast } from "@/plugins/util";

export default {
  name: "DetailComment",
  components: {
    // ScrollComp,
    SendArticleBox,
    CommentListItem,
    CommentDialog,
    SightseerCommentTips,
    DetailAd
  },
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    user: {
      type: Object,
      default: () => ({})
    },
    list: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({})
    },
    loadCommentStatus: {
      type: String,
      default: ""
    },
    /** 是页面中的评论还是弹窗中的评论 */
    isPage: { type: Boolean, default: false },
    navType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      showToolBar: false
    };
  },
  computed: {
    ...mapGetters(["loginUid", "loginUser"])
  },
  watch: {
    loadCommentStatus(val, oVal) {
      this.$refs.scrollComp && (this.$refs.scrollComp.loadStatus = val);
    }
  },
  mounted() {
    // 锚点定位
    setTimeout(() => {
      const ancher_id = sessionStorage.getItem("jumpDetailAnchorId");
      if (ancher_id) {
        window.scrollTo({
          top: document.getElementById(ancher_id).offsetTop,
          behavior: "smooth"
        });
        sessionStorage.removeItem("jumpDetailAnchorId");
      }
    }, 1000);
    // 查询未发出的评论
    const storeComment = localStorage.getItem("__comment_store__");

    if (storeComment && this.isLogin()) {
      if (!this.isAuthRealName("实名认证后才能评论")) {
        return false;
      }
      const commentParams = JSON.parse(storeComment);
      this._comment(commentParams);
    }
  },
  beforeDestroy() {
    eventBus.$off("onCommentLoginClose", this.sightseerComment);
  },
  methods: {
    // 游客评论
    sightseerComment: newDebounce(function() {
      // 查询未发出的评论
      const storeComment = localStorage.getItem("__comment_store__") || "";
      const params = JSON.parse(storeComment);
      apiSightseerCommentAdd(params)
        .then(res => {
          if (res && res.code === 0) {
            this.$refs.sightseerCommentTips.open();
            // 10s后自动关闭
            setTimeout(() => {
              this.$refs.sightseerCommentTips.close();
            }, 10000);
          }
        })
        .finally(() => {
          // 删除缓存
          localStorage.removeItem("__comment_store__");
          eventBus.$off("onCommentLoginClose", this.sightseerComment);
        });
    }, 1000),
    // 添加评论
    onComment(data) {
      const { text, resources } = data;
      let content = text;
      if (resources.length) {
        let imgs = '<div class="comment-img-wrapper">';
        resources.forEach(item => {
          imgs += `<div class="img-item"><img src="${item.url}" alt=""></div>`;
        });
        imgs += "</div>";
        content += imgs;
      }
      let params = {
        content: content,
        content_id: Number(this.detail.id),
        pid: 0
      };
      this.navType && (params.type = this.navType);

      // 校验
      if (!data.text) {
        this.$message({
          type: "info",
          message: "内容为空，请输入！"
        });
        return;
      }
      if (!this.isLoginShow("", "commentLogin")) {
        // 监听是否关闭登录框回调
        eventBus.$on("onCommentLoginClose", this.sightseerComment);
        localStorage.setItem("__comment_store__", JSON.stringify(params));
        return false;
      }
      if (!this.isAuthRealName("实名认证后才能评论")) return false;
      console.log(params);
      this._comment(params);
    },
    _comment(params) {
      apiCommentAdd(params)
        .then(({ code, data }) => {
          if (code === 0) {
            // this.$message.success("评论成功");
            toast("评论成功");
            this.detail.comment_count++;
            this.$emit("refresh", this.detail);
            this.getCommentList("refresh");
            this.$refs.sendBox.onClear();
          }
        })
        .finally(_ => {
          this.$emit("setLoading", false);
          // 删除缓存
          localStorage.removeItem("__comment_store__");
          eventBus.$off("onCommentLoginClose", this.sightseerComment);
        });
    },
    // 获取评论列表
    getCommentList(type) {
      this.$emit("getCommentList", type);
    },
    // 删除评论
    onDelComment(item) {
      let index = this.list.indexOf(item);
      this.list.splice(index, 1);
      this.detail.comment_count--;
      this.$emit("refresh", this.detail);
    },
    // 置顶评论
    onTopComment(item) {
      this.$emit("getCommentList", "refresh");
    },
    // 滚动到评论处
    async onScrollToCommentBox() {
      if (!this.isLoginShow()) return false;

      let $ele = this.$refs.sendComment;
      $ele.querySelector(".article-edit-box").focus();
      await this.$nextTick();
      window.scrollTo({
        top: $ele.offsetTop,
        behavior: "smooth"
      });
    },
    onInputFocus() {
      this.showToolBar = true;
    },
    onInputCancel() {
      this.showToolBar = false;
      this.$refs.sendBox.onClear();
    },
    handleClickEdit() {
      if (!this.isLoginShow("")) return false;
      if (!this.isAuthRealName("")) return false;
      this.$router.push(`/${this.gameInfo.alias}/editor`);
    }
  }
};
</script>

<style lang="less" scoped>
.detail-comment {
  background-color: #fff;
  border-radius: 2px;
  margin-top: 4px;
  padding: 10px 0;
}
.wiki-detail-body {
  padding: 10px 14px;
}

.mode-line {
  padding: 8px 10px;
  .mode-btn {
    display: flex;
    width: 86px;
    height: 24px;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    font-size: 12px;
    color: #424242;
    background-color: #e3e6ee;
    cursor: pointer;
  }
}

.wiki-comment-list {
  background: #fff;
  margin-top: 10px;
  border-radius: 2px;
  margin-top: 28px;
  margin-top: 4px;
  padding: 10px 0;

  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .comment-num {
    color: #333;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
    span {
      color: #333;
      font-size: #666;
      font-weight: 400;
    }
  }
}

.empty-box {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 90px;
  .empty-icon {
    width: 107px;
    height: 80px;
    margin-bottom: 29px;
  }

  .empty-txt {
    font-weight: 400;
    font-size: 12px;
    color: #9c9ea2;
    line-height: 17px;
    margin-bottom: 10px;
  }

  .btn-box {
    text-align: center;
    .button {
      font-weight: 400;
      font-size: 12px;
      color: #00afe8;
      line-height: 17px;
    }
  }
}
/deep/ .comment-img-wrapper {
  display: flex;
  margin-bottom: 20px;

  .img-item {
    width: 110px;
    height: 100px;
    cursor: pointer;
    position: relative;
    border-radius: 6px;
    overflow: hidden;

    & + .img-item {
      margin-left: 12px;
    }

    .mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: fade(#000, 70%);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 16px;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
